import React, { useState } from 'react';
import { Link as RouterLink, useSearchParams } from 'react-router-dom';
import { Container, Paper, TextField, Button, Typography, Box, Alert, Link } from '@mui/material';
import axios from 'axios';

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setMessage('');
    if (password !== confirm) {
      setError('Пароли не совпадают');
      return;
    }
    setLoading(true);
    try {
      const response = await axios.post('/api/auth/reset-password', {
        token,
        new_password: password,
      });
      setMessage(response.data?.message || 'Пароль успешно изменён');
    } catch (err) {
      setError(err.response?.data?.error || 'Не удалось сменить пароль');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container component="main" maxWidth="xs">
      <Box sx={{ marginTop: 8, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Paper elevation={3} sx={{ p: 4, width: '100%' }}>
          <Typography component="h1" variant="h5" align="center" gutterBottom>
            Новый пароль
          </Typography>
          {!token && <Alert severity="error" sx={{ mb: 2 }}>В ссылке нет токена сброса</Alert>}
          {message && <Alert severity="success" sx={{ mb: 2 }}>{message}</Alert>}
          {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
          <Box component="form" onSubmit={handleSubmit}>
            <TextField
              margin="normal"
              required
              fullWidth
              type="password"
              label="Новый пароль"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <TextField
              margin="normal"
              required
              fullWidth
              type="password"
              label="Подтверждение"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
            />
            <Button type="submit" fullWidth variant="contained" sx={{ mt: 2, mb: 2 }} disabled={loading || !token}>
              Сохранить пароль
            </Button>
            <Link component={RouterLink} to="/login" variant="body2">
              Перейти ко входу
            </Link>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
}
